import { getSubscriptionPlanKey, getSubscriptionTier, isAnnualSubscriptionPlan, } from '../subscriptions/SubscriptionTier';
const allowedEvaluateTags = [
    'guest',
    'signedIn',
    'isSubscribed',
    'subscribed',
    'subscribedBasic',
    'subscribedBasicAnnual',
    'subscribedBusiness',
    'subscribedPremium',
    'subscribedPremiumAnnual',
    'freeMeal',
    'mobileApp',
    'mobileWeb',
    'desktopWeb',
    'kiosk',
    'showSunsetPointsInfo',
    'defaultProductCatalog',
    'home',
    'subscriptionPlans',
    'pendingOrder',
    'productCatalog',
    'landingPageMobile',
    'androidApp',
    'iOSApp',
    'landingPageKiosk',
    'userProfilePointsRN',
    'landingPageRN',
    'basketPageRN',
    'guestRN'
];
const generateExpression = (evaluatedTags, expressionTags) => {
    const generateFunction = new Function(`{ ${allowedEvaluateTags.join(', ')} }`, expressionTags);
    return Boolean(generateFunction(evaluatedTags));
};
const generateEvaluateTags = (data) => {
    var _a;
    const planKey = getSubscriptionPlanKey(data.subscriptionType);
    const tier = getSubscriptionTier(data.subscriptionType);
    const isAnnual = isAnnualSubscriptionPlan(data.subscriptionType);
    const isEmployee = tier === 'employee';
    return Object.assign(Object.assign({ guest: !(data.userData && data.userData.token), signedIn: Boolean(data.userData && data.userData.token), mobileApp: data.channel === 'mobileApp', mobileWeb: data.channel === 'mobileBrowser', desktopWeb: data.channel === 'desktopBrowser', kiosk: data.channel === 'kiosk', defaultProductCatalog: data.page === 'defaultProductCatalog', isSubscribed: !isEmployee && Boolean(data.subscriptionType), subscribed: !isEmployee && (Boolean(data.OTP) || Boolean(data.subscriptionType)), freeMeal: Boolean(data.subscriptionType) && Boolean(data.hasFreeMeal), isEmployee, subscribedBasic: planKey === 'Basic' || (tier === 'basic' && !isAnnual), subscribedBasicAnnual: planKey === 'BasicAnnual' || (tier === 'basic' && isAnnual), subscribedPremium: planKey === 'Premium' || (tier === 'premium' && !isAnnual), subscribedPremiumAnnual: planKey === 'PremiumAnnual' || (tier === 'premium' && isAnnual), subscribedBusiness: planKey === 'Business' || tier === 'business' }, ('showSunsetPointsInfo' in data ? { showSunsetPointsInfo: data.showSunsetPointsInfo } : null)), { home: data.page === 'home', landingPageKiosk: data.page === 'landingpagekiosk', subscriptionPlans: data.page === 'subscriptionPlans', pendingOrder: !!data.page && data.page.toLowerCase() === 'pendingorder', productCatalog: !!data.page && data.page.toLowerCase() === 'productcatalog', landingPageMobile: !!data.page && data.page.toLowerCase() === 'landingpagemobile', androidApp: data.platform === 'android', iOSApp: data.platform === 'ios', userProfilePointsRN: data.segment === '/(tabs)/user-profile', landingPageRN: data.segment === '/(tabs)/(home)', basketPageRN: data.segment === '/catalog/basket', guestRN: (_a = data.guestRN) !== null && _a !== void 0 ? _a : false });
};
export { generateExpression, generateEvaluateTags, allowedEvaluateTags };
